export default __webpack_public_path__ + "static/media/sideArrowActive.832edc23.svg";